import { Box } from '@mui/material';

import ClientList from './components/ClientList';

const ClientListingPage = () => {
  return (
    <Box borderRadius={1.5}>
      <ClientList source="ClientListing" />
    </Box>
  );
};

export default ClientListingPage;
